module.exports = __webpack_public_path__ + "assets/img/logo-en.0cbc07c7.png";